// extracted by mini-css-extract-plugin
export default {"button":"ArchiveStoryActionsContainer-button-50955c339588409e165762326e62d538"};